import { TechnologyLevels } from '@/types';

export const technologyLevels: Record<TechnologyLevels, string> = {
  [TechnologyLevels.NICE_TO_HAVE]: 'Nice to have',
  [TechnologyLevels.JUNIOR]: 'Junior',
  [TechnologyLevels.REGULAR]: 'Regular',
  [TechnologyLevels.MASTER]: 'Master',
  [TechnologyLevels.ADVANCED]: 'Advanced'
};
